import { HttpWebtrack } from 'utility/http';
import { store } from '@redux/storeConfig/store';
import configureInterceptors from 'utility/http/interceptors/configure-interceptors';

export interface DeviceChannelInfo {
  videoStreamingChannels: number;
  deviceModelName: string;
  brandName: string;
}

// Función para obtener la información de canales basada en el deviceIdentifier
export const getDeviceChannelInfo = async (
  deviceIdentifier: string
): Promise<DeviceChannelInfo | null> => {
  try {
    const httpWebtrack = new HttpWebtrack();
    configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);

    // Usar el endpoint del IoTHub controller
    const response = await httpWebtrack.post(`/IoTHub/device-info`, {
      deviceIdentifier
    });

    if (response.data?.Success) {
      const videoChannels = response.data.Data?.VideoStreamingChannels;
      return {
        videoStreamingChannels:
          videoChannels !== null && videoChannels !== undefined ? videoChannels : 0, // 0 para dispositivos sin video
        deviceModelName: response.data.Data?.DeviceModelName || 'Unknown',
        brandName: response.data.Data?.BrandName || 'Unknown'
      };
    }

    return null;
  } catch (error) {
    console.error('Error fetching device channel info:', error);
    return null;
  }
};

// Función para generar la lista de canales basada en la cantidad
export const generateChannelList = (maxChannels: number): number[] => {
  return Array.from({ length: maxChannels }, (_, i) => i + 1);
};
